<section class="main-block">
  <div style="display: flex; flex-direction: column">
    <div style="order: 1">
      <h1>Help</h1>
      <p>App Version: {{ appVersion }}</p>
      <p>API Version: {{ apiVersion }}</p>
    </div>
  </div>
</section>
